<template>
  <div v-if="!showRequest">
    <v-card class="fullForm">
      <div class="fullText" v-if="!khoroojInfo.NeedSchoolConfirm">
        مشمول گرامي، براي ثبت درخواست خروج از كشور بر اساس لينك زير اقدام كنيد:
        <br />
        <br />
        <a target="_blank" :href="`https://hozehkh.com/res/` + khoroojInfo.DocumentName" style="display: block">
          راهنمای خروج از کشور
        </a>
      </div>
      <div v-else class="fullText">
        {{ khoroojInfo.Description }}

        <br />
        <div style="width: 100%">
          <v-simple-checkbox v-model="showRequest" @input="handleShowRequest" :ripple="false"></v-simple-checkbox>
          <b>موارد فوق را با دقت مطالعه كردم و نسبت به رعایت آن متعهد مي شوم.</b>
        </div>
      </div>
    </v-card>
  </div>
  <div v-else>
    <v-card class="form">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>کشور مقصد:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-select :items="khoroojInfo.AllowCountry" v-model="country"></v-select>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>تاریخ تقریبی شروع سفر:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-btn class="form-center" color="orange white--text" rounded @click="onClickDate(1)">
            {{ startSelected ? startDate : "انتخاب تاریخ" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>تاریخ تقریبی پایان سفر:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-btn class="form-center" color="orange white--text" rounded @click="onClickDate(2)">
            {{ endSelected ? endDate : "انتخاب تاریخ" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>توضیحات:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-textarea outlined v-model="comment" no-resize></v-textarea>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn color="primary white--text" class="register" rounded @click="applyRequest">
          ثبت
        </v-btn>
      </v-row>
    </v-card>
    <date-picker ref="datepicker1" v-model="startDate" :editable="false" :auto-submit="true" element="fileInput1"
      :min="TODAY" @change="onChangeDate($event, 1)"></date-picker>
    <input id="fileInput1" ref="fileInput1" />
    <date-picker ref="datepicker2" v-model="endDate" :editable="false" :auto-submit="true" element="fileInput2"
      :min="startDate" @change="onChangeDate($event, 2)"></date-picker>
    <input id="fileInput2" ref="fileInput2" />
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
import { requestKhorooj } from "@/api/khorooj";
import { TODAY } from "@/utils/constants";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      showRequest: false,
      country: "",
      startDate: TODAY,
      endDate: TODAY,
      startSelected: false,
      endSelected: false,
      comment: "",
      TODAY: TODAY,
    };
  },
  methods: {
    /**
     * user want to change date
     */
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    /**
     * user changed date
     */
    onChangeDate($event, input) {
      let date = moment($event).format("jYYYY/jMM/jDD");
      if (input == 1) {
        this.startDate = date;
        this.startSelected = true;
      } else {
        this.endDate = date;
        this.endSelected = true;
      }
    },
    /**
     * check user input and  then send khorooj request
     */
    applyRequest() {
      var text = "";
      if (!this.startSelected) {
        text = "لطفا زمان شروع را انتخاب کنید.";
      } else if (!this.endSelected) {
        text = "لطفا زمان پایان را انتخاب کنید.";
      } else if (this.startDate > this.endDate) {
        text = "زمان شروع بایستی پیش از زمان پایان باشد.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        requestKhorooj(this.country, this.startDate, this.endDate, this.comment)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

            if (data.Success) {
              this.startDate = TODAY;
              this.endDate = TODAY;
              this.startSelected = false;
              this.endSelected = false;
              this.comment = "";

              this.$router.push({ path: "/khorooj-history" });
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
    handleShowRequest() {
      window.scrollTo(0, 0)
      this.$router.push({
        query: {

          showRequest: "true"
        }
      });

    }

  },

  /**
   * get khorooji meta data
   */
  created() {
    if (this.$route.query.showRequest) {
      this.$router.replace({
        query: {}
      })
    }
    this.$store.dispatch("getKhoroojInfo").then(() => {
      this.country = this.khoroojInfo.AllowCountry[0];
    });
  },
  computed: {
    khoroojInfo() {
      return this.$store.getters.khoroojInfo;
    },
  },
  '$route'(to, from) {
    this.showRequest = !!this.$route.query.showRequest;
    window.scrollTo(0, 0)
  }

};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}

.v-simple-checkbox {
  top: -5px;
  position: relative;
  margin: 2px 0 0 5px;
  float: right;
}

.register {
  width: 300px !important;
  margin: 15px auto;
}

@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
